function initialiseConversationSearch() {
    const minimumQueryLength = 3;
    const root = document.querySelector('[data-conversation-search]');
    const modal = document.getElementById('conversationSearchModal');
    if (!root || !modal || root.dataset.initialised === 'true') return;
    root.dataset.initialised = 'true';

    const input = document.getElementById('conversation-search-input');
    const results = root.querySelector('[data-search-results]');
    const state = root.querySelector('[data-search-state]');
    const items = root.querySelector('[data-search-items]');
    const end = root.querySelector('[data-search-end]');
    if (!input || !results || !state || !items || !end) return;

    let timer = null;
    let controller = null;
    let nextSearchPosition = null;
    let hasMoreResults = false;
    let loading = false;
    let generation = 0;

    const clearElement = element => {
        while (element.firstChild) element.removeChild(element.firstChild);
    };

    const showState = (icon, primary, secondary = '', retry = false) => {
        clearElement(state);
        state.classList.remove('d-none');
        const iconElement = document.createElement('i');
        iconElement.className = `bi ${icon} conversation-search-state-icon`;
        iconElement.setAttribute('aria-hidden', 'true');
        state.appendChild(iconElement);
        const primaryElement = document.createElement('p');
        primaryElement.className = `mb-0 mt-2${secondary ? ' font-weight-bold' : ''}`;
        primaryElement.textContent = primary;
        state.appendChild(primaryElement);
        if (secondary) {
            const secondaryElement = document.createElement('p');
            secondaryElement.className = 'mb-0 mt-2';
            secondaryElement.textContent = secondary;
            state.appendChild(secondaryElement);
        }
        if (retry) {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'btn btn-outline-primary mt-3';
            button.textContent = 'Retry';
            button.addEventListener('click', () => runSearch(false));
            state.appendChild(button);
        }
    };

    const reset = () => {
        generation += 1;
        if (timer) window.clearTimeout(timer);
        controller?.abort();
        controller = null;
        input.value = '';
        clearElement(items);
        end.classList.add('d-none');
        nextSearchPosition = null;
        hasMoreResults = false;
        loading = false;
        showState('bi-search', 'Enter at least three characters to search your archived discussions.');
        results.scrollTop = 0;
    };

    const appendResult = result => {
        const link = document.createElement('a');
        link.className = 'conversation-search-result';
        link.href = root.dataset.conversationUrl.replace('__id__', encodeURIComponent(result.conversationId));
        const icon = document.createElement('i');
        icon.className = 'bi bi-chat-text conversation-search-result-icon';
        icon.setAttribute('aria-hidden', 'true');
        const content = document.createElement('span');
        content.className = 'conversation-search-result-content';
        const date = document.createElement('span');
        date.className = 'conversation-search-result-date';
        date.textContent = result.updated;
        const excerpt = document.createElement('span');
        excerpt.className = 'conversation-search-result-excerpt';
        const matchStart = Number.isInteger(result.matchStart) ? result.matchStart : -1;
        const matchLength = Number.isInteger(result.matchLength) ? result.matchLength : 0;
        if (matchStart >= 0 && matchLength > 0 && matchStart + matchLength <= result.excerpt.length) {
            excerpt.appendChild(document.createTextNode(result.excerpt.slice(0, matchStart)));
            const match = document.createElement('strong');
            match.textContent = result.excerpt.slice(matchStart, matchStart + matchLength);
            excerpt.appendChild(match);
            excerpt.appendChild(document.createTextNode(result.excerpt.slice(matchStart + matchLength)));
        } else {
            excerpt.textContent = result.excerpt;
        }
        content.append(date, excerpt);
        link.append(icon, content);
        items.appendChild(link);
    };

    async function runSearch(loadMore) {
        const term = input.value.trim();
        if (term.length < minimumQueryLength || loading || (loadMore && !hasMoreResults)) return;
        loading = true;
        const requestGeneration = generation;
        if (!loadMore) {
            controller?.abort();
            controller = new AbortController();
            clearElement(items);
            end.classList.add('d-none');
            nextSearchPosition = null;
            hasMoreResults = false;
            showState('bi-hourglass-split', 'Searching…');
        }

        const url = new URL(root.dataset.searchUrl, window.location.origin);
        url.searchParams.set('query', term);
        if (loadMore && nextSearchPosition) url.searchParams.set('searchPosition', nextSearchPosition);

        try {
            const response = await fetch(url, { signal: controller?.signal, headers: { Accept: 'application/json' } });
            if (!response.ok) throw new Error('Search request failed');
            const page = await response.json();
            if (requestGeneration !== generation || term !== input.value.trim()) return;
            state.classList.add('d-none');
            page.items.forEach(appendResult);
            nextSearchPosition = page.nextSearchPosition;
            hasMoreResults = page.hasMoreResults;
            if (items.childElementCount === 0) {
                showState('bi-x-circle', `No results for '${term}'`, 'There are no discussions in your archives that include this search term');
            } else if (!hasMoreResults) {
                end.classList.remove('d-none');
            }
        } catch (error) {
            if (error.name !== 'AbortError' && requestGeneration === generation) {
                showState('bi-exclamation-circle', 'Search could not be completed.', 'Please try again.', true);
            }
        } finally {
            if (requestGeneration === generation) loading = false;
        }
    }

    input.addEventListener('input', () => {
        generation += 1;
        if (timer) window.clearTimeout(timer);
        controller?.abort();
        loading = false;
        clearElement(items);
        end.classList.add('d-none');
        const term = input.value.trim();
        if (term.length < minimumQueryLength) {
            showState('bi-search', 'Enter at least three characters to search your archived discussions.');
            return;
        }
        timer = window.setTimeout(() => runSearch(false), 300);
    });

    results.addEventListener('scroll', () => {
        if (results.scrollHeight - results.scrollTop - results.clientHeight < 100) runSearch(true);
    });
    $(modal).on('shown.bs.modal', () => input.focus());
    $(modal).on('hidden.bs.modal', reset);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseConversationSearch);
} else {
    initialiseConversationSearch();
}
